import AuthUITemplate from "./AuthUI";
import { useEffect } from "react";
import Button from "../../components/common/Button";
import { Link, Navigate } from "react-router-dom";
import { useResetPassword } from "react-redux-django-auth";
import useAuthRedirect from "../../hooks/useAuthRedirect";
import { useToast } from "../../hooks/otherHooks/useToast";
import Input from "../../components/common/Input";
import { Mail } from "lucide-react";

const ResetPassword = () => {
    const { email, error, handleChange, handleSubmit, loading, isStatus204 } =
        useResetPassword();

    // Toast
    const { showToast, redirectPage } = useAuthRedirect(isStatus204);

    const { addToast } = useToast();

    useEffect(() => {
        if (showToast) {
            addToast({
                message: "Reset Password Email Sent",
                bg: "success",
            });
        }
    }, [showToast, addToast]);

    if (redirectPage) {
        return <Navigate to="/login" />;
    }
    return (
        <AuthUITemplate title="Reset Password" errorMsg={error}>
            <form className="cht-space-y-4" onSubmit={(e) => handleSubmit(e)}>
                <Input
                    label="Email Address"
                    labelClassName="cht-text-[10px] cht-font-black cht-text-white/70 cht-uppercase cht-tracking-widest"
                    type="email"
                    id="email"
                    name="email"
                    placeholder="name@company.com"
                    leftIcon={<Mail size={18} />}
                    onChange={(e: any) => handleChange(e)}
                    value={email}
                    required
                />

                <Button
                    type="submit"
                    variant="primary"
                    size="lg"
                    fullWidth
                    isLoading={loading}
                    disabled={loading}
                    className="cht-w-full cht-mt-4 cht-py-4 cht-uppercase cht-tracking-widest cht-text-xs cht-rounded-2xl"
                >
                    Reset Password
                </Button>
            </form>
            <div className="cht-mt-6 cht-text-center">
                <p className="cht-text-xs cht-font-medium cht-text-white/60">
                    Already have an account?{" "}
                    <Link to="/login" className="cht-text-white cht-font-black hover:cht-underline cht-ml-1">
                        Log In
                    </Link>
                </p>
            </div>
        </AuthUITemplate>
    );
};

export default ResetPassword;
